// extracted by mini-css-extract-plugin
export default {"container":"W0-z","list":"X0-z"};